module.exports = __webpack_public_path__ + "img/laboral.4c00bf69.png";